<template>
  <div>
    <button
      class="enable-sound"
      @click="enableSound"
    >
      <svg v-if="soundEnabled" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M14.016 3.234q3.047 0.656 5.016 3.117t1.969 5.648-1.969 5.648-5.016 3.117v-2.063q2.203-0.656 3.586-2.484t1.383-4.219-1.383-4.219-3.586-2.484v-2.063zM16.5 12q0 2.813-2.484 4.031v-8.063q1.031 0.516 1.758 1.688t0.727 2.344zM3 9h3.984l5.016-5.016v16.031l-5.016-5.016h-3.984v-6z"></path>
      </svg>
      <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z"></path>
      </svg>
    </button>
    <section class="wrapper wrapper--overview">
      <div class="section-wrapper--overview">
        <section class="section section--incoming incoming">
          <div class="header">
            <img
              :src="asset(themeValue('THEME_LOGO'))"
              alt="miss-miu_logo"
              class="header__logo"
            >
            <h1 v-html="langValue('LANG_ORDERS_NEW')"/>
          </div>
          <div class="grid">
            <GridBox :order="order" v-for="order in newOrderList" :key="order.id"></GridBox>
          </div>
        </section>
        <section class="section section--preparation preparation">
          <div class="header">
            <h1 v-html="langValue('LANG_ORDERS_PREP')"/>
          </div>
          <section class="grid">
            <GridBox :order="order" v-for="order in prepOrderList" :key="order.id"></GridBox>
          </section>
        </section>
      </div>

      <section class="section section--pick-up pick-up">
        <div class="header">
          <h1 v-html="langValue('LANG_ORDERS_PICKUP')"/>
        </div>
        <section
          :class="[
            hasFeature('FEATURE_ORDERBOXES') ? `pick-up__grid pick-up__grid--cols-${boxColumns}` : 'grid',
          ]"
        >
          <template v-if="hasFeature('FEATURE_ORDERBOXES')">
            <GridBox :order="order" v-for="order in pickupOrderBoxList" :key="order.id"></GridBox>
          </template>
          <template v-else>
            <GridBox :order="order" v-for="order in pickupOrderList" :key="order.id"></GridBox>
          </template>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import GridBox from '@num/components/GridBox'
import MixinOrderList from '@num/mixins/MixinOrderList'
import { startUpdateOrderListInterval } from "@num/controller";
import { eventhub, EVENT_ORDER_PICKUP } from '@num/store/eventhub';

export default {
  mixins: [
    MixinOrderList
  ],
  components: {
    GridBox,
  },
  data() {
    return {
      loading: false,
      sound: null,
      ordersNotified: [],
      soundEnabled: false,
    };
  },
  methods: {
    detectOrderPickup(orderList) {
      const newOrders = orderList.filter(order => {
        return !this.ordersNotified.includes(order.id);
      });

      this.ordersNotified.push(...newOrders.map(order => order.id));

      if (newOrders.length) {
        try {
          this.soundEnabled && this.sound.play();
        }
        catch(error) {
          // do nothing
        }
      }
    },
    enableSound() {
      this.sound.play();
      this.sound.pause();
      this.soundEnabled = !this.soundEnabled;
    }
  },
  mounted() {
    this.sound = new Audio('/sounds/point-blank.mp3');

    startUpdateOrderListInterval()
    eventhub.$on(EVENT_ORDER_PICKUP, this.detectOrderPickup);
  },
  destroyed() {
    eventhub.$off(EVENT_ORDER_PICKUP, this.detectOrderPickup);
  }
};

</script>

<style>
</style>
